// extracted by mini-css-extract-plugin
export var cardWrapper = "_46-0";